import Header from "components/Common/Header/Header";
import MyTaskGanttBody from "components/MyTaskComponents/MyTaskGantt/MyTaskGanttBody";
import React, { useEffect } from "react";

const MyTaskGantt = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "My Task";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="mytask" />

      <MyTaskGanttBody />
    </main>
  );
};

export default MyTaskGantt;
